import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import { merge } from 'lodash-es';
import { useIsInBottomSheet } from '../BottomSheet';
import { useDevice } from '../Device';
import { useOverlayContext } from '../OverlayContext';
import { useIsInModal } from '../OverlayContext/ModalContainer';
import { BaseTextField } from '../TextField/BaseTextField/BaseTextField';
import { MobileSelect, SelectOptionsBottomSheet } from './MobileSelect';
export const Select = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { isMobileDevice } = useDevice();
    const isInBottomSheet = useIsInBottomSheet();
    const isInModal = useIsInModal();
    const { pushBottomSheetPage } = useOverlayContext();
    if (isInBottomSheet) {
        return /*#__PURE__*/ _jsx(BaseTextField, _object_spread_props(_object_spread({}, props), {
            ref: ref,
            select: true,
            SelectProps: merge(props.SelectProps, {
                open: false,
                onOpen: ()=>{
                    pushBottomSheetPage({
                        content: /*#__PURE__*/ _jsx(SelectOptionsBottomSheet, _object_spread({
                            saveOnSelect: true
                        }, props))
                    });
                }
            })
        }));
    } else if (isMobileDevice && !isInModal) {
        return /*#__PURE__*/ _jsx(MobileSelect, _object_spread_props(_object_spread({}, props), {
            ref: ref
        }));
    } else {
        return /*#__PURE__*/ _jsx(BaseTextField, _object_spread_props(_object_spread({}, props), {
            ref: ref,
            select: true
        }));
    }
});
